import {config} from './config'

export const baseURL = config.BASE_URL;